export const checkIsSubscribed = async (email: string, setIsSubscribed: React.Dispatch<React.SetStateAction<boolean>>, setStatus: React.Dispatch<React.SetStateAction<string>>, setIsLoading: React.Dispatch<React.SetStateAction<boolean>>, setPromoViewed: React.Dispatch<React.SetStateAction<boolean>>
) => {
    setIsLoading(true);
    if (!email) {
        setIsSubscribed(false);
    }
    const response = await fetch('/api/user/waitlist', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
    });
    const data = await response.json();
    if (data.message === "success") {
        setIsSubscribed(true);
        setStatus(data.status);
        setTimeout(() => {
            setPromoViewed(true);
            localStorage.setItem('promoViewed', 'true');
        }, 2000);
    } else {
        setIsSubscribed(false);
    }
    setIsLoading(false);
}

export const isValidEmail = (email: string) => {
    const strictRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!strictRegex.test(email)) {
        return false;
    }
    return true;
}